const apiUrl = process.env.REACT_APP_API_URL;

const getSampleSummary = (token, id, cb) => {
    fetch(`${apiUrl}/conditionreportsamplesummary/${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getSampleSummary;
